<template>
<div style=" height:60px; background-color: #06bafc;" class="report-nav-container">
  <loading :show="show"
     :label="label"></loading>
     <div class="row" style="height:100%;">
    <div class="col-sm-6 col-xs-6 previous">
      <span v-if="placement[sectionNumber - 1]" @click="previous()" style="display:block; margin:auto;">
        <img src="../../assets/arrow-pointing-to-left.svg" alt="previous">
        Previous
      </span>
      </div>
    <div class="col-sm-6 col-xs-6 next">
      <span @click="next()" style="display:block; margin:auto;">
        Continue
        <img src="../../assets/right-arrow-nav.svg" alt="">
      </span>
    </div>
  </div>
</div>

</template>

<script>
import store from '../../store.js';
import { mapState } from 'vuex';
import constants from '../../constants';
import { ReportWizard, Indicator } from '../../api';
import Loading from 'vue-full-loading';

export default {
  data () {
    return {
      show: false,
      label: "Generating Report...",
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState({
      sectionNumber: state => state.sectionNumber,
      placement: state => state.placement,
      reportObject: state => state.reportObject,
    }),
  },
  methods: {
    showNotification (type, content) {
      this.$notify({
        type: type,
        content: content
      });
    },
    previous: function () {
      if (this.sectionNumber > 0) {
          store.state.sectionNumber--;
      } else if(!this.placement[this.sectionNumber]){
          store.state.sectionNumber++;
      }
    },
  next: async function () {
      let section_name = this.placement[this.sectionNumber]
      if (section_name === 'name') {
        let response;
        let _this = this;
        let data = null;
        let type = null;
        let geoJsonObjects = null;
        let reportId = null;
        if (this.reportObject['name'] === undefined){
          this.showNotification('warning', "Please enter a report name to continue")
        }else {_this.show = true;
        await ReportWizard.createReport(this.reportObject).then(function(response){
          if (response){
            type = response.type;
            reportId = response.id;
            if (response.hasOwnProperty('comparative')){
              this.comparativeResult = response.comparative;
            }
            store.dispatch('setDataType', type);
            if (type === 'shp') {
              _this.$router.push({ path: `/reports/${reportId}/details`});
            }else if (type === 'xls' || type=== 'xlsx') {
              store.dispatch('setXlsData');
              _this.$router.push({ path: `/reports/${reportId}/details`});
            }

            _this.showNotification('success', "Successfully created report");
          } else {
            _this.showNotification('danger', "Failed to create report! Ensure the report name is unique and try again.");
            }
            _this.show = false;
            store.state.sectionNumber = 0;
          });
        }
      }else{
          if (section_name === constants.WIZARD_DATA_SOURCE){
            if(this.reportObject['data_sources'].length === 0){
              this.showNotification('warning', `Please select a data source`)
              return;
            }else{
              store.state.sectionNumber++;
            }
          } else if (store.state.reportObject[section_name] !== undefined){
            store.state.sectionNumber++;
          }else{
              this.showNotification('warning', `Please select an ${_.startCase(section_name).toLowerCase()}`)
          }
          if (!this.placement[this.sectionNumber]){
            this.reportObject['transformation'] = {};
            return;
          }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.next > span{
  float:right;
}
.previous > span, .next > span {
  margin-top:8px;
  cursor: pointer;
  color: white;
  font-weight: bold;
}
.previous, .next{
  border-right: 1px solid white;
  display: flex;
  height: 100%;
}

@media (max-width:720px){

}

</style>





// WEBPACK FOOTER //
// src/components/report/ReportWizardNavigation.vue